
const digest = '1cb8113b47492e12848c5081aaaa32af06552c410e75c0dbb60b89738b301102';
const css = `._editLink_1f6p2_1 {
  box-sizing: border-box;
  padding: var(--spacer-2);
  display: flex;
  flex-direction: column;
  gap: var(--spacer-3);
}
._label_1f6p2_8 {
  display: flex;
  flex-direction: column;
  gap: var(--spacer-1);
}
._labelName_1f6p2_13 {
  font-size: 11px;
  color: var(--theme-tertiary-text);
}
._input_1f6p2_17[type='text'] {
  text-overflow: ellipsis;
  &::placeholder {
    color: var(--theme-input-placeholder);
  }
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"editLink":"_editLink_1f6p2_1","label":"_label_1f6p2_8","labelName":"_labelName_1f6p2_13","input":"_input_1f6p2_17"};
export { css, digest };
  